// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__XXb-I","info":"Panel_info__XxiJg","btns":"Panel_btns__nHTYb","button":"Panel_button__nO5ST"};